/**
 * Organization brand utilities shared by the main header (App.vue).
 *
 * // Note: Mirrors sign-only-website-static's utils/brand.js.
 */

import documillLogo from '../assets/img/documill-logo-32x32.svg';

/**
 * Organization's brand logo URL, falling back to the default Documill logo when the
 * organization has no custom brand configured.
 *
 * @param {Object} brand organization brand, as returned by
 *   store.getters.getOrganizationBrand, or null/undefined if the organization has no custom
 *   brand configured
 * @return {String} the header logo URL
 */
function getHeaderLogoUrl(brand) {
  if(brand && brand.logoId)
    return window.FlowWebsiteGlobalConfig.basePaths.flowController + "/v1/organization/brand/image/" + brand.logoId;

  return documillLogo;
}

export { getHeaderLogoUrl };
